<input
  #input
  class="text-input"
  type="text"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [attr.aria-invalid]="error ? true : null"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [attr.maxlength]="maxLength"
  [attr.aria-describedby]="describedBy"
  (focus)="inputFocused.emit()"
  (input)="handleInput($event)" />
